import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled, { css } from "styled-components";
import { fontWeights } from "healthex-common/weights";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { BaseBlueTextButton, BaseOutlinedTextButton } from "./base.styles";
export const HXDesktopBannerContainer = styled(FlexRowDiv) `
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    ${(props) => props.type === "NORMAL" &&
    css `
            padding: 16px;
            border: ${props.hideBorder ? "none" : `1px solid ${colors.accents_sunset}`};
            background: #fff6ee;
        `}

    ${(props) => props.type === "WARNING" &&
    css `
            padding: 16px;
            border: ${props.hideBorder ? "none" : `1px solid ${colors.tulip_main}`};
            background: ${colors.tulip_8};
        `}

    ${(props) => props.type === "SECONDARY" &&
    css `
            padding: 0;
        `}
`;
export const HXDesktopBannerTextContainer = styled(FlexColumnDiv) `
    padding: 0;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
`;
export const HXDesktopBannerText = styled.div `
    color: ${colors.black_light};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const HXDesktopBannerErrorText = styled.div `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.4px;
`;
export const HXDesktopBannerErrorLink = styled(AnchorLink) `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    text-decoration: underline;
    letter-spacing: 0.4px;

    &:hover {
        color: ${colors.tulip_dark};
    }
`;
export const HXDesktopBannerCancelButton = styled(BaseBlueTextButton).attrs({ color: "primary" }) `
    margin-right: 4px;
`;
export const HXDesktopBannerButton = styled(BaseOutlinedTextButton) ``;
